import { readBarcodes } from 'zxing-wasm';

// Cache the BarcodeDetector instance to avoid recreating it on each call
let cachedBarcodeDetector: BarcodeDetector | null = null;

const getBarcodeDetector = () => {
	if (!cachedBarcodeDetector && 'BarcodeDetector' in globalThis) {
		cachedBarcodeDetector = new BarcodeDetector({
			formats: ['qr_code'],
		});
	}
	return cachedBarcodeDetector;
};

export const readBarcode = async (imageData: ImageData) => {
	const detector = getBarcodeDetector();

	if (detector) {
		const result = (await detector.detect(imageData)) ?? [];
		return result.map((symbol) => ({
			typeName: symbol.format,
			data: symbol.rawValue,
		}));
	} else {
		// Fallback to zxing-wasm for browsers without native BarcodeDetector
		const result = await readBarcodes(imageData);
		return result.map((symbol) => ({
			typeName: symbol.format,
			data: symbol.text,
		}));
	}
};
